export default {
  transactions: 'Transactions',
  assets: 'Assets',
  revenueByMonth: 'Revenue by month',
  inflowOutflowByMonth: 'Inflow/outflow by month',
};
